import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  makeStyles,
} from '@material-ui/core';
import { DOC_TYPES } from '../types';
import { ItemCardGrid, ItemCardHeader } from '@backstage/core-components';
import { singular } from 'pluralize';

type CreateDocDialogProps = {
  onClose: () => void;
  open: boolean;
};

const useStyles = makeStyles(() => ({
  card: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  cardContent: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  cookingExample: {
    marginTop: '1rem',
    minHeight: '3lh',
  },
}));

export const CreateDocDialog = (props: CreateDocDialogProps) => {
  const { onClose, open } = props;
  const classes = useStyles();

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
      <DialogTitle>Create New Document</DialogTitle>
      <DialogContent>
        <ItemCardGrid>
          {Object.entries(DOC_TYPES).map(([_, docType]) => (
            <Card className={classes.card}>
              <CardMedia>
                <ItemCardHeader title={singular(docType.title)} />
              </CardMedia>
              <CardContent className={classes.cardContent}>
                <p>{docType.description}</p>
                <section className={classes.cookingExample}>
                  <strong>Example:</strong>
                  <p>
                    <em>{docType.example.title}</em>
                  </p>
                  <p>{docType.example.summary}</p>
                </section>
              </CardContent>
              <CardActions>
                <Button
                  variant="outlined"
                  color="primary"
                  href={`/create/templates/default/${docType.templateName}`}
                  target="_blank"
                >
                  Create
                </Button>
              </CardActions>
            </Card>
          ))}
        </ItemCardGrid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};
